<template lang="html">

    <section class="comunicaciones" v-if="data.length != 0">
      <h1>{{$t('encuestas')}}</h1>
  
      <div class="comunicaciones-list container -xs">
  
  
        <article class="comunicacion" v-for="(el,key) in data.splice(0,2)" :haslink="!!el.urlAcceso">
  
          <main>
  
            <h2>{{el.titulo}}</h2>
  
            <a :href="brand.dominioEncuesta+el.urlAcceso" target="_blank" v-if="!!el.urlAcceso" class="link">{{$t('ver_mas')}}</a>
  
          </main>
  
        </article>
  
      </div>
  
  
    </section>
  
  </template>
  
  <script lang="js">
  
      import {mapActions,mapGetters} from 'vuex';
  
      export default  {
        name: 'encuestas',
        mounted(){
          setTimeout(e => {
            this.requestEncuestas().then( r =>{
              this.data = r;
            })
          },200)
          
        },
        data(){
          return{
            data : ''
          }
        },
        computed:{
            ...mapGetters({
                brand : 'getBrand'
            })
        },
        methods: {
           ...mapActions(['requestEncuestas'])
        },
    }
    </script>
  <style scoped lang="scss">
      .comunicaciones {
    
      }
    </style>


// WEBPACK FOOTER //
// src/components/parts/encuestas.vue